
import React, { useState } from 'react';
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import { RenderInputsRowByType } from '../../../components/formGroupGenerator/RenderInputRowByType';

export const CambioProgramaInput = ({ disabled, idEvaluacion, loadingOthersButtons, handleClickAceptar }) => {
    const [openModal, setOpenModal] = useState(false);

    const handleOpenModal = () => setOpenModal(true);
    const handleClose = () => setOpenModal(false);

    const handleAccept = () => {
        // agregar la logica del cambio de programa
        handleClickAceptar();
    }

    return (
        <>
            <RenderInputsRowByType
                input={{
                    displayName: 'Cambiar Programa',
                    name: 'cambiarPrograma',
                    type: 'button',
                    isLoading: loadingOthersButtons,
                    disabled: disabled,
                    variant: 'outlined',
                    col: 30,
                    onClick: () => handleOpenModal()
                }}
                value={null}
                handleChange={null}
            />
            <CustomDialog
                maxWidth='sm'
                fullWidth
                onCancel={() => handleClose()}
                onAccept={() => { setOpenModal(false); handleAccept() }}
                open={openModal}
                cancelText='Cancelar'
                acceptText='Aceptar'
                title={'¿Está seguro que desea cambiar de programa?'}
            >

            </CustomDialog>
        </>
    );
}
